import moment from "moment-timezone";

export const ACTIVE_PERIOD_FIELDS = ["activePeriodStart", "activePeriodEnd"];

const storedDate = (value: any) => (value ? moment(value).toDate() : null);

/**
 * What the two pickers display: the site's stored period, or null (shown as
 * N/A) when it has none. Compute this once per site and keep it, because
 * applyActivePeriod compares against the exact object the form started with.
 */
export const initialActivePeriod = (site: any) => ({
  activePeriodStart: storedDate(site?.activePeriodStart),
  activePeriodEnd: storedDate(site?.activePeriodEnd)
});

// Guard the falsy cases before moment sees them: moment(undefined) is *now*,
// not an invalid date, so an unset picker would silently become today.
const time = (value: any) => (value ? moment(value).valueOf() : null);

/**
 * Persist the active period only if the user actually changed it, so editing a
 * site for an unrelated reason cannot resend dates nobody touched. The two
 * dates are one period: when either changed, both are sent, because consumers
 * read them as a pair and an end date sent alone is not picked up.
 * Dates go to the API as epoch ms, matching renewalDate.
 *
 * This compares against the form's initial values rather than Formik's
 * `touched`: a date picker never blurs, so Formik would not mark it touched,
 * and `onSubmit`'s helpers argument carries no touched state anyway.
 */
export const applyActivePeriod = (
  siteData: any,
  values: any,
  initial: any
) => {
  const next = { ...siteData };
  const periodChanged = ACTIVE_PERIOD_FIELDS.some(
    (field: string) => time(values?.[field]) !== time(initial?.[field])
  );

  ACTIVE_PERIOD_FIELDS.forEach((field: string) => {
    const chosen = time(values?.[field]);

    if (periodChanged && chosen) {
      next[field] = chosen;
    } else {
      delete next[field];
    }
  });

  return next;
};
